/**
 * Auth0 Callback Handler - Simplified for Pages
 *
 * Just shows a loading state.
 * Auth0Provider handles the actual callback processing via onRedirectCallback.
 */

export function AuthCallback() {
  // Simple loading state - Auth0Provider handles everything
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500 mx-auto mb-6"></div>
        <h2 className="text-2xl font-bold text-white mb-3">
          Completing Sign In
        </h2>
        <p className="text-white/80">
          Please wait...
        </p>
      </div>
    </div>
  );
}
